export default "__VITE_ASSET__CmW0woef__"